<script lang="ts">
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { LinkEntity } from "@shared/services/event_tracking/entities";
  import { reformatUrlAndGetTargetValue } from "@shared/services/target_value_forward_urls";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  export let targetObjectType: string | null = null;
  export let forwardLink;
  export let linkText;

  const { trackClick } = EventTracking;
  const trackingParams: LinkEntity = new LinkEntity({ forward_url: forwardLink });

  const { href, target } = reformatUrlAndGetTargetValue(forwardLink);
</script>

<TrackingContext entities={trackingParams} let:trackingContext>
  <a
    {href}
    {target}
    class="fizz-text-strong fizz-text-medium"
    data-testid={targetObjectType}
    style="white-space: nowrap;"
    on:click={() => trackClick(targetObjectType, trackingContext.entities)}>{linkText}</a
  >
</TrackingContext>
